import { gql } from '@apollo/client';


export const query = gql`
  query obtenerNumeralia($annio: Int!){
    numeralia:consultarnumeralia(annio: $annio){
      academicos
      estudiantes{
        key
        doc_count
      }
      proyectos
      publicaciones
      actividades
      educontinua
      cursosposgrado
      convenios
      prensa
    }
  }
`

